import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import { localStorageKeys } from 'src/app/shared/constants';
import { IWootricConfig } from '../../models/wootric-config';

/**
 * Extends the Window type to include the wootric stuff
 */
declare global {
  interface Window {
    wootric: (a: string) => void;
    wootricSettings: IWootricConfig;
    wootric_survey_immediately: boolean;
    wootric_no_surveyed_cookie: boolean;
    Cypress?: unknown;
    WootricSurvey: {
      stop: () => void;
    };
  }
}

window.wootric = window.wootric || undefined;

export interface IWootricService {
  update(wootricUserData: IWootricConfig);
  init();
}

@Injectable({
  providedIn: 'root',
})
export class WootricService implements IWootricService {
  initialized = false;
  stopped = false;
  scriptLoaded$: BehaviorSubject<boolean>;

  constructor() {
    this.scriptLoaded$ = new BehaviorSubject(false);
  }

  update(wootricConfigData: IWootricConfig) {
    window.wootricSettings = wootricConfigData;

    this.scriptLoaded$.subscribe((loaded) => {
      if (loaded && window.wootric && !this.stopped) {
        window.wootric('run');
      }
    });
  }

  init() {
    if (!this.initialized) {
      this.initialized = true;

      if (
        !environment.wootricEnabled ||
        localStorage.getItem(localStorageKeys.disableWootric) ||
        !!window?.Cypress
      ) {
        return;
      }

      if (environment.wootricDebug) {
        window.wootric_survey_immediately = true;
        window.wootric_no_surveyed_cookie = true;
      }

      const script = document.createElement('script');

      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://cdn.wootric.com/wootric-sdk.js';
      script.onload = () => {
        this.scriptLoaded$.next(true);
      };

      document.body.appendChild(script);
    }
  }

  stop() {
    //hides the wootric survey
    this.stopped = true;
    if (this.initialized) {
      this.scriptLoaded$.subscribe((loaded) => {
        if (loaded && window.WootricSurvey) {
          window.WootricSurvey.stop();
        }
      });
    }
  }
}
